import React from 'react';
import CrearIngresos from '../../../components/insumos/ingresos/CrearIngresos';

const CrearIngresosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <CrearIngresos />
    </div>
  );
};

export default CrearIngresos;